var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// src/components/StatusList.tsx
import { closestCenter, DndContext } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import StatusItem from '../status-item/index';
var StatusList = function (_a) {
    var statuses = _a.statuses, setStatuses = _a.setStatuses, isEditing = _a.isEditing, deleteItem = _a.deleteItem, maxOrder = _a.maxOrder;
    var handleDragEnd = function (event) {
        var _a;
        var active = event.active, over = event.over;
        if (!over || active.id === over.id)
            return;
        // Prevent dragging if active or over is the first item
        var firstItemId = (_a = statuses[0]) === null || _a === void 0 ? void 0 : _a.id;
        if (active.id === firstItemId || (over === null || over === void 0 ? void 0 : over.id) === firstItemId) {
            return;
        }
        setStatuses(function (prevStatuses) {
            var oldIndex = prevStatuses.findIndex(function (item) { return item.id === active.id; });
            var newIndex = prevStatuses.findIndex(function (item) { return item.id === over.id; });
            // Move the item in the array
            var newStatuses = arrayMove(prevStatuses, oldIndex, newIndex);
            // Update order values sequentially
            return newStatuses.map(function (status, index) {
                var _a;
                return (__assign(__assign({}, status), { order: index + 1, 
                    // Also update subStages if needed (optional)
                    subStages: (_a = status.subStages) === null || _a === void 0 ? void 0 : _a.map(function (subStage, subIndex) { return (__assign(__assign({}, subStage), { order: subIndex + 1 })); }) }));
            });
        });
    };
    return (_jsx(DndContext, { collisionDetection: closestCenter, onDragEnd: handleDragEnd, children: _jsx(SortableContext, { items: statuses, strategy: verticalListSortingStrategy, children: statuses.length == 0 ? (_jsx("div", { className: 'px-[20px]', children: "To Add Stages Click on \"Manage Status\" button and then \"Add status\"" })) : (statuses.map(function (status, index) { return (_jsx(StatusItem, { status: status, isEditing: isEditing, setStatuses: setStatuses, isFirst: status.isDefault, index: index, deleteItem: deleteItem, maxOrder: maxOrder }, status.id)); })) }) }));
};
export default StatusList;
